import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import noData from "../../../src/shared/images/noUrl.jpg";
import './NoURL.scss';
import { faDashboard, faDatabase, faLock, faUser } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useSharedState } from "../../components/services/WindowSizeService";

import { useNavigate } from "react-router";
const NoURL = () => {
    const windowSize$ = useSharedState();
    const navigate = useNavigate();
    const [submitFlag, setSubmitFlag] = useState<boolean>(false);
    const [inputs, setInputs] = useState<any>({});
    const [disabledLogin, setDisabledLogin] = useState<any>(false);

    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values: any) => ({ ...values, [name]: value }))
    }


    // Validating and appending the device details for the URL
    const validateURL = () => {
        if (inputs?.firmwareVersion > 0 && inputs?.deviceID) {
            let data: any = inputs?.firmwareVersion + '&iLens-SCN101&' + inputs?.deviceID;
            navigate('/p/config/deviceConfig/' + data);
            window.location.reload();
        }
    }

    const submitForm = () => {
        setSubmitFlag(true);
        validateURL();
    }

    return (
        <div className="login">
            <div className="login-row">
                <div className="row m-0">
                    {windowSize$ === "sm" || windowSize$ === "xs" ?
                        <>
                            <div className="login-container mt-5 col-md-12">
                                <div className="">
                                    <div>
                                        <div className="main-head">
                                            DATA LOGGER
                                        </div>
                                        <div className="sign-in my-4">
                                            Enter Device Details
                                        </div>
                                    </div>
                                    <div className="my-3">
                                        <div className="my-4">
                                            <FontAwesomeIcon icon={faUser} className="mr-2" />
                                            <label className="label-style" >Device ID</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="text"
                                                name="deviceID"
                                                value={inputs?.deviceID ? inputs?.deviceID : ""}
                                                placeholder="Device ID"
                                                className="form-control form-control-bordered my-2"
                                                autoComplete="nope"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.deviceID &&
                                                <div className="text-danger">Please Enter Device ID</div>
                                            }
                                        </div>
                                        <div className="my-4">
                                            <FontAwesomeIcon icon={faLock} className="mr-2" />
                                            <label className="label-style">Password</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="text"
                                                name="firmwareVersion"
                                                value={inputs?.firmwareVersion ? inputs?.firmwareVersion : ""}
                                                placeholder="Password"
                                                className="form-control form-control-bordered my-2"
                                                // autoComplete="new-password"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.password &&
                                                <div className="text-danger">Please Enter Password</div>
                                            }
                                        </div>
                                        <div className=" pt-0 my-4 py-3" >
                                            <button attr-test="modal-submit" type="button" className="btn btn-login  w-100" onClick={submitForm}>
                                                <span className="login-label">
                                                    Submit
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="col-md-8 col-lg-8 pl-0">
                                <img src={noData} className="ilens-login" alt="Data Logger" />
                            </div>
                            <div className="login-container col-md-4">
                                <div>
                                    <div>
                                        <div className="main-head">
                                            DATA LOGGER
                                        </div>
                                        <div className="sign-in my-3">
                                            Enter Device Details
                                        </div>
                                    </div>
                                    <div className="my-2">
                                        <div className="my-4">
                                            <FontAwesomeIcon icon={faDashboard} className="mr-2" />
                                            <label className="label-style" >Device ID</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="text"
                                                name="deviceID"
                                                value={inputs?.deviceID ? inputs?.deviceID : ""}
                                                placeholder="Device ID"
                                                className="form-control form-control-bordered my-2"
                                                autoComplete="nope"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.deviceID &&
                                                <div className="text-danger">Please Enter Device ID</div>
                                            }
                                        </div>
                                        <div className="my-4">
                                            <FontAwesomeIcon icon={faDatabase} className="mr-2" />
                                            <label className="label-style">Firmware Version</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="number"
                                                name="firmwareVersion"
                                                value={inputs?.firmwareVersion ? inputs?.firmwareVersion : ""}
                                                placeholder="Firmware Version"
                                                className="form-control form-control-bordered my-2"
                                                // autoComplete="new-password"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.firmwareVersion &&
                                                <div className="text-danger">Please Enter Firmware Version</div>
                                            }

                                        </div>
                                        <div className=" pt-0 my-4 py-1" >
                                            <button attr-test="modal-submit" type="button" disabled={disabledLogin} className="btn btn-login  w-100" onClick={submitForm}>
                                                <span className="login-label">
                                                    {disabledLogin ?
                                                        <>Loading..</>
                                                        :
                                                        <>Submit</>
                                                    }
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
export default NoURL;